<p-dialog
  [header]="header"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!sending"
  [closeOnEscape]="!sending"
  [style]="{ width: '640px' }"
  [breakpoints]="{ '700px': '95vw' }"
  appendTo="body"
>
  <div class="reply">
    <div class="reply-to">
      <span class="field-label">Do:</span>
      <app-user-account-link [email]="email" [userGuid]="userGuid" />
    </div>

    @if (thread.length) {
      <div class="thread" #threadBox>
        @for (message of thread; track $index) {
          <div class="thread-item" [class.outgoing]="message.outgoing" [class.current]="message.current">
            <div class="thread-meta">{{ message.at | date: 'yyyy-MM-dd HH:mm' }} · {{ message.label }}</div>
            @if (message.subject) {
              <div class="thread-subject">{{ message.subject }}</div>
            }
            <div class="thread-text">{{ message.text }}</div>
          </div>
        }
      </div>
    }

    <label for="reply-subject" class="field-label">Temat</label>
    <input
      id="reply-subject"
      pInputText
      [ngModel]="subject"
      (ngModelChange)="subjectChange.emit($event)"
      [disabled]="sending"
    />

    <label for="reply-body" class="field-label">Treść</label>
    <textarea
      id="reply-body"
      pInputTextarea
      rows="12"
      [ngModel]="body"
      (ngModelChange)="bodyChange.emit($event)"
      [disabled]="sending"
    ></textarea>

    @if (hint) {
      <div class="field-hint">{{ hint }}</div>
    }

    @if (error) {
      <div class="reply-error">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ error }}</span>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Anuluj" [text]="true" [disabled]="sending" (onClick)="close()" data-clarity-unmask="true" />
    <p-button label="Wyślij odpowiedź" icon="pi pi-send" [loading]="sending" [disabled]="!canSend" (onClick)="send.emit()" data-clarity-unmask="true" />
  </ng-template>
</p-dialog>
